import { StageId } from "../types";

/** ゲーム実行中の状態（真実の単一ソース） */
export interface RunState {
  /** 現在の敵文字列 */
  sentence: string;
  /** 次に正解すべき文字のインデックス */
  nextIndex: number;
  /** 次に正解すべき文字 */
  nextChar: string;
  /** 現在のステージ */
  stage: StageId;
  /** スコア */
  score: number;
  /** 連続ヒット数 */
  combo: number;
  /** コンボ倍率 */
  comboMult: number;
  /** ヒット回数 */
  hits: number;
  /** ミス回数 */
  misses: number;
  /** 最後にヒットした時刻(ms) */
  lastHitAtMs: number;
  /** EMAヒット間隔(ms) */
  emaHitIntervalMs: number;
  /** 最大コンボ倍率（記録用） */
  maxComboMult: number;
}

/** RunStateの初期値を生成 */
export function createRunState(sentence: string): RunState {
  return {
    sentence,
    nextIndex: 0,
    nextChar: sentence.charAt(0),
    stage: "S1",
    score: 0,
    combo: 0,
    comboMult: 1.0,
    hits: 0,
    misses: 0,
    lastHitAtMs: 0,
    emaHitIntervalMs: 900,
    maxComboMult: 1.0,
  };
}
